export enum DeleteAccountReasonType {
  ABUSE = 16,
  ANOTHER_ACCOUNT = 21,
  APP_BEHAVIOR = 22,
  NOT_INTERESTED = 12,
  OTHER = 20,
}
